import React from "react";
import { Button } from "react-bootstrap";
import { PaginationInfo } from "../types";

interface PaginationControlsProps {
  pagination: PaginationInfo;
  onPageChange: (xPage: number, yPage: number) => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
  pagination,
  onPageChange,
}) => {
  const { xPage, xTotal, yPage, yTotal, xPageSize, yPageSize } = pagination;

  const xMaxPage = Math.max(0, Math.ceil(xTotal / xPageSize) - 1);
  const yMaxPage = Math.max(0, Math.ceil(yTotal / yPageSize) - 1);

  const xStart = xPage * xPageSize + 1;
  const xEnd = Math.min((xPage + 1) * xPageSize, xTotal);
  const yStart = yPage * yPageSize + 1;
  const yEnd = Math.min((yPage + 1) * yPageSize, yTotal);

  const needsPagination = xTotal > xPageSize || yTotal > yPageSize;
  if (!needsPagination) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 0",
        fontSize: "0.8rem",
      }}
    >
      {/* Y pagination (rows) */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ color: "var(--text-muted)" }}>
          Rows {yStart}-{yEnd} of {yTotal}
        </span>
        <Button
          variant="secondary"
          size="sm"
          disabled={yPage === 0}
          onClick={() => onPageChange(xPage, yPage - 1)}
          style={{ padding: "2px 8px", fontSize: "0.75rem" }}
        >
          &#9650;
        </Button>
        <Button
          variant="secondary"
          size="sm"
          disabled={yPage >= yMaxPage}
          onClick={() => onPageChange(xPage, yPage + 1)}
          style={{ padding: "2px 8px", fontSize: "0.75rem" }}
        >
          &#9660;
        </Button>
      </div>

      {/* X pagination (columns) */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Button
          variant="secondary"
          size="sm"
          disabled={xPage === 0}
          onClick={() => onPageChange(xPage - 1, yPage)}
          style={{ padding: "2px 8px", fontSize: "0.75rem" }}
        >
          &#9664;
        </Button>
        <Button
          variant="secondary"
          size="sm"
          disabled={xPage >= xMaxPage}
          onClick={() => onPageChange(xPage + 1, yPage)}
          style={{ padding: "2px 8px", fontSize: "0.75rem" }}
        >
          &#9654;
        </Button>
        <span style={{ color: "var(--text-muted)" }}>
          Cols {xStart}-{xEnd} of {xTotal}
        </span>
      </div>
    </div>
  );
};

export default PaginationControls;
